export default __webpack_public_path__ + "static/media/Prompt-Regular.89910a38.ttf";